// extracted by css-extract-rspack-plugin
export default {"arrowIcon":"profile-nav-menu-option-module__arrowIcon___sboBq"};